import React from "react";

import './VideoTagsContainer.scss'
import VideoTag from '../VideoTag/VideoTag'
import TagHelper from '../../../helpers/PostHelpers/TagHelper'

const VideoTagsContainer = ({ videoTagList = [] }) => {
  const normalizedTags = TagHelper.extractTagNamesFromObjects(videoTagList);
  if (!normalizedTags.length) {
    return null;
  }
  return (
    <div className = "video-tags-container">
    {normalizedTags.map((tagName, index) => 

      (<VideoTag key={`${tagName}-${index}`} tagName={tagName} />)
    )
    }
    </div>
   
  );
};

export default VideoTagsContainer;
